import { Navigate, Route, Routes, useParams } from 'react-router';
import Config, { type MultiLang } from '../config';
import Credits from '../credits/Credits';
import CreditsXoopsPathRedirect from '../credits/CreditsXoopsPathRedirect';
import Database from '../database/Database';
import DatabaseXoopsPathRedirect from '../database/DatabaseXoopsPathRedirect';
import MediaWikiUtils from '../mediawiki/lib/MediaWikiUtils';
import MediaWiki from '../mediawiki/MediaWiki';
import MediaWikiXoopsPathRedirect from '../mediawiki/MediaWikiXoopsPathRedirect';
import Pico from '../pico/Pico';
import PicoXoopsPathRedirect from '../pico/PicoXoopsPathRedirect';
import XoopsPathRedirect from './XoopsPathRedirect';

interface Props {
    lang: MultiLang;
}

const MediaWikiRoute = (props: Props) => {
    const { name = '' } = useParams<{ name?: string }>();
    return <MediaWiki lang={props.lang} name={name} />;
};

const MainContent = (props: Props) => {
    const { lang } = props;
    return (
        <div className="mainContent">
            <Routes>
                <Route path="/database/*" element={<Database lang={lang} />} />
                <Route path="/credits/*" element={<Credits lang={lang} />} />
                {Config.PICO_MODULES.map((name) => (
                    <Route key={name} path={`/${name}/*`} element={<Pico lang={lang} name={name} />} />
                ))}
                <Route
                    path="/mediawiki"
                    element={<Navigate to={`/mediawiki/${MediaWikiUtils.getMainPageName(lang)}`} replace />}
                />
                <Route path="/mediawiki/:name" element={<MediaWikiRoute lang={lang} />} />
                <Route path="/modules/xoonips/*" element={<DatabaseXoopsPathRedirect lang={lang} />} />
                <Route path="/modules/credits/*" element={<CreditsXoopsPathRedirect lang={lang} />} />
                {Config.PICO_MODULES.map((name) => (
                    <Route
                        key={name}
                        path={`/modules/${name}/*`}
                        element={<PicoXoopsPathRedirect lang={lang} name={name} />}
                    />
                ))}
                <Route path="/modules/mediawiki/*" element={<MediaWikiXoopsPathRedirect lang={lang} />} />
                <Route path="*" element={<XoopsPathRedirect lang={lang} />} />
            </Routes>
        </div>
    );
};

export default MainContent;
